<template>
  <div class="AnswerDetail">
    <div class="answer_detail" :style="'width:'+myProductDivWidth+'px;'" v-loading="detailLoading">
      <div v-if="routeFromList" class="back_btn" @click="backTolist">
        <i class="el-icon-back"> 返回</i>
      </div>
      <div class="answer_title">
        {{answer.title}}
      </div>
      <div class="answer_update_time">
        更新日期：{{answer.updateTime}}
      </div>
      <div class="answer_content">
        <p v-html = "answer.content"></p>
      </div>
      <div class="answer_useful">
        <span>是否对你有帮助？</span>
        <el-button size="medium" round :disabled="disablebtn" @click="usefulHandler">是</el-button>
        <el-button size="medium" round :disabled="disablebtn" @click="uselessHandler">否</el-button>
      </div>
      <div class="answer_feedback" v-if="isUseless">
        <div class="answer_feedback_tip">为了提供更好的帮助，请告诉我们原因</div>
        <el-input
            type="textarea"
            :rows="3"
            maxlength="200"
            show-word-limit
            v-model="advice">
        </el-input>
        <div style="text-align: center;padding: 10px">
          <button class="feedback_btn" @click.once="feedbackHandler">提交</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: "AnswerDetail",
        data() {
            return {
                myProductDivWidth: document.documentElement.clientWidth - 58,
                detailLoading: false,
                routeFromList:true,
                answerId: '',
                answer: '',
                disablebtn: false,
                isUseless: false,
                advice:'',
                feedback:{}
            }
        },
        created() {
            this.answerId = this.$route.params.answerId;
            if(!this.answerId){
                this.answerId = this.$route.query.answerId;
                this.routeFromList = false;
            }
            // console.log("routeFromList: ",this.routeFromList);
            if(this.answerId){
                this.detailLoading = true;
                this.$axios.get(this.$baseURL + `/answer/detail/`+this.answerId)
                    .then((response)=> {
                        this.answer = response.data;
                        console.log(this.answer);
                        this.detailLoading = false;
                        this.clickNum(this.answerId);
                    }).catch(error=> {
                        console.log(error);
                        this.detailLoading = false;
                        this.$message({
                            type: 'warning',
                            message: '获取知识文章失败，请重试',
                            offset: 30
                        });
                    });
            }
        },
        methods: {
            // 点击量
            clickNum(aid){
                this.$axios.put(this.$baseURL + `/answer/click/`+aid)
                    .then((response)=> {
                        if(response.status==202){
                            console.log("文章点击 +1");
                        }
                    }).catch(()=> {
                        // DO NOTHING
                    });
            },
            // 返回列表页
            backTolist(){
                this.$router.push({
                    name:"AnswerList"
                })
            },
            // 反馈：有用
            usefulHandler(){
                this.disablebtn = true;
                this.feedbackHandler();
            },
            // 反馈：无用
            uselessHandler(){
                this.disablebtn = true;
                this.isUseless = true;
            },
            feedbackHandler(){
                console.log("提交反馈");
                console.log(this.answerId);
                this.feedback.answerId = Number(this.answerId);
                this.feedback.useFlag = this.isUseless?0:1;
                this.feedback.advice = this.advice;
                console.log(this.feedback)
                this.$axios.post(this.$baseURL + `/answer/feedback`,this.$qs.stringify(this.feedback))
                    .then((response)=> {
                        console.log(response);
                        this.$message({
                            type: 'success',
                            message: '感谢您的反馈',
                            offset: 60
                        });
                    }).catch(()=> {
                    // DO NOTHING
                });
            }
        }
    };
</script>

<style scoped>

  .AnswerDetail {
    background: #FFF;
    border: 1px solid #DCDFE6;
    box-shadow: 0 2px 4px 0 rgba(0,0,0,.12), 0 0 6px 0 rgba(0,0,0,.04);
  }
  .answer_detail {
    padding: 30px 20px;
    text-align: left;
    font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
  }
  .answer_title {
    font-size: 20px;
    color: #3e5c9a;
    margin: 30px 0px;
  }
  .answer_update_time {
    font-size: 12px;
    margin-bottom: 5px;
    color: #999b9d;
  }
  .answer_content{
    margin: 20px 0px;
    padding: 20px 0px;
    border-top: 1px solid #c5c5c5;
    border-bottom: 1px solid #c5c5c5;
  }
  .answer_useful {
    text-align: right;
    font-size: 14px;
    margin-bottom: 5px;
    font-weight: 600;
  }
  .el-button.is-round {
    background-color: #002878bd;
    color: white;
    border-radius: 6px;
  }
  .el-button+.el-button {
    margin-left: 5px;
  }
  .is-disabled {
    background-color: white!important;
    color: #C0C4CC!important;
  }
  .answer_feedback {
    padding: 20px;
    display: block;
  }
  .answer_feedback_tip{
    color: #3e5c9a;
    font-size: 14px;
    padding: 10px 0px 5px 5px;
  }
  .feedback_btn {
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    border: 1px solid #DCDFE6;
    text-align: center;
    box-sizing: border-box;
    outline: 0;
    margin: 0;
    border-radius: 4px;
    padding: 12px 20px;
    background-color: #002878bd;
    color: white;
  }
  .back_btn {
    float: left;
    font-size: 15px;
  }
</style>
